import React, { FC, useState } from 'react'

import { downloadFile, Loading, mainColors, Tooltip } from '@avantstay/backoffice-core'

import { IconDownload } from '@avantstay/backoffice-vectors'
import * as S from '../FilePreviewActions/FilePreviewActions.styles'

interface DownloadPhotoProps {
  decodedFileName: string
  fileUrl?: string
}

export const DownloadPhoto: FC<DownloadPhotoProps> = ({ decodedFileName, fileUrl }) => {
  const [loadingPhoto, setLoadingPhoto] = useState(false)

  if (!fileUrl) {
    return null
  }

  const handleDownload = async () => {
    setLoadingPhoto(true)

    try {
      await downloadFile(fileUrl, decodedFileName, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Content-Type': 'image/*',
        },
      })
    } finally {
      setLoadingPhoto(false)
    }
  }

  return (
    <Tooltip content="Download file" placement="top">
      <S.ActionIconWrapper>
        {loadingPhoto ? (
          <Loading color={mainColors.neutralExtremelyDark} size="3px" />
        ) : (
          <IconDownload onClick={handleDownload} />
        )}
      </S.ActionIconWrapper>
    </Tooltip>
  )
}
